/* VIDEO LAZYLOAD — ver docs/performance/video-lazyload.md

   O <video> chega do snippets/lazy-video.liquid com poster (video.preview_image) e as
   fontes em data-src. Aqui a gente troca data-src por src quando o vídeo se aproxima da
   viewport e chama load(); o atributo autoplay nativo, quando existe, faz o resto.

   Reescrito em 20/Ago/2026. A versão anterior era o exemplo do web.dev cru e tinha três
   limitações que os vídeos deste tema encontram na prática:
     1. sem rootMargin — o download só começava quando o vídeo JÁ estava visível, então
        dava pra ver o poster congelado esperando os primeiros bytes;
     2. varria o DOM uma única vez, no DOMContentLoaded — os slides clonados pelo swiper
        das galerias e a .productView trocada pelo gd-variant-swap.js nunca eram vistos;
     3. nada garantia o carregamento antes de um play() imperativo — e o PiP do
        video-wrapper.js e do video-gallery.js clona o <video> e chama play() no MESMO
        tick, antes de qualquer callback de IntersectionObserver rodar.
*/
(function () {
  "use strict";

  var SELECTOR = "video.lazy";
  var ROOT_MARGIN = "400px 0px";

  var observer = null;

  function load(video) {
    if (!video || video.dataset.lazyLoaded === "true") return;
    video.dataset.lazyLoaded = "true";

    var sources = video.querySelectorAll("source[data-src]");
    for (var i = 0; i < sources.length; i++) {
      sources[i].src = sources[i].dataset.src;
    }

    // O poster tambem espera, quando o snippet o emitiu como data-poster (galerias muito
    // abaixo da dobra). Promover aqui, e nao no HTML, tira 205 KiB da disputa por banda
    // antes do LCP — ver docs/performance/html-e-main-thread.md.
    if (video.dataset.poster) {
      video.poster = video.dataset.poster;
      delete video.dataset.poster;
    }

    // O snippet emite preload="none" — é o que impede o download antes da hora. Escrever
    // o src e chamar load() com preload="none" ainda NÃO baixa nada, então aqui a gente
    // libera: quem tem autoplay vai baixar de qualquer forma; quem não tem (os slides das
    // galerias, que só tocam no clique) fica em "metadata", que é o que essas sections
    // pediam ao video_tag antes — só que agora perto da viewport, não no carregamento.
    video.preload = video.hasAttribute("autoplay") ? "auto" : "metadata";

    video.load();
    // sai do SELECTOR: um scan() posterior não reprocessa, e clones deste nó já nascem
    // carregados (cloneNode copia o src que acabamos de escrever)
    video.classList.remove("lazy");

    if (observer) observer.unobserve(video);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var videos = scope.querySelectorAll(SELECTOR);

    for (var i = 0; i < videos.length; i++) {
      if (observer) observer.observe(videos[i]);
      else load(videos[i]); // sem IntersectionObserver: carrega tudo e segue a vida
    }
  }

  if ("IntersectionObserver" in window) {
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) load(entry.target);
        });
      },
      { rootMargin: ROOT_MARGIN }
    );
  }

  // Rede de segurança pros play() imperativos do tema (video-wrapper.js e
  // video-gallery.js somam 9 pontos, incluindo os PiP que clonam e tocam no mesmo tick).
  // Um patch único e estreito em vez de espalhar chamadas nesses dois arquivos: eles são
  // do tema e voltam sobrescritos nos commits "Update from Shopify for theme guday/main".
  var nativePlay = HTMLMediaElement.prototype.play;
  HTMLMediaElement.prototype.play = function () {
    if (this.tagName === "VIDEO" && this.classList.contains("lazy")) load(this);
    return nativePlay.apply(this, arguments);
  };

  window.gdLazyVideo = { load: load, scan: scan };

  /* IMAGENS DIFERIDAS DE VERDADE — ver docs/performance/html-e-main-thread.md

     `loading="lazy"` nao basta em conexao lenta: a margem que o Chrome usa cresce com a
     qualidade da rede, e imagem a 3.200 px da dobra baixa junto com a primeira dobra.
     Medido em 11/09/2026 na home: 236 KiB do aside-media-banner, TODOS ja com
     loading="lazy", competindo por banda antes do LCP.

     A classe `gd-lazy-img` e obrigatoria de proposito: os .card-icon-hover tambem usam
     data-src, mas quem os promove e o pointerover logo abaixo — se este observer os
     pegasse no scroll, o deferimento deles seria desfeito.

     Em <picture>, os <source> tem que ser escritos ANTES do src do <img>: depois que o
     img ja tem src o navegador nao reavalia os candidatos. */
  var SELECTOR_IMG = "img.gd-lazy-img[data-src], img.gd-lazy-img[data-srcset]";
  var observerImg = null;

  function carregaImg(img) {
    if (!img || img.dataset.lazyImgLoaded === "true") return;
    img.dataset.lazyImgLoaded = "true";

    var pai = img.parentElement;
    if (pai && pai.tagName === "PICTURE") {
      var fontes = pai.querySelectorAll("source[data-srcset]");
      for (var i = 0; i < fontes.length; i++) {
        fontes[i].srcset = fontes[i].dataset.srcset;
        fontes[i].removeAttribute("data-srcset");
      }
    }
    if (img.dataset.srcset) {
      img.srcset = img.dataset.srcset;
      img.removeAttribute("data-srcset");
    }
    if (img.dataset.src) {
      img.src = img.dataset.src;
      img.removeAttribute("data-src");
    }
    if (observerImg) observerImg.unobserve(img);
  }

  function scanImg(root) {
    var escopo = root && root.querySelectorAll ? root : document;
    var imgs = escopo.querySelectorAll(SELECTOR_IMG);
    for (var i = 0; i < imgs.length; i++) {
      if (observerImg) observerImg.observe(imgs[i]);
      else carregaImg(imgs[i]);
    }
  }

  if ("IntersectionObserver" in window) {
    observerImg = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) carregaImg(entry.target);
        });
      },
      { rootMargin: ROOT_MARGIN }
    );
  }

  window.gdLazyImg = { load: carregaImg, scan: scanImg };

  /* SLIDES DA GALERIA DO PRODUTO — ver docs/performance/html-e-main-thread.md

     Do 2o slide em diante o snippets/product-gallery.liquid emite data-src/data-srcset.
     Aqui eles sao promovidos na PRIMEIRA interacao com a galeria.

     Sao DOIS gatilhos, porque a galeria tem dois layouts:

     - No mobile ela e carrossel: antes de o slick inicializar os slides tem caixa 0x0
       (e por isso o `loading="lazy"` nativo nao os defere), e depois ficam fora da tela na
       horizontal. Geometria nao serve de sinal ali; a interacao com a galeria serve.
     - No DESKTOP ela e grid (`.productView-nav.style-2`): os slides tem caixa real, ficam
       no fluxo da pagina e o usuario so rola. Sem gatilho de interseccao eles nunca
       carregavam — foi a regressao de 11/09/2026, com o grid mostrando celulas vazias.

     O observer por isso exige caixa com area: slide 0x0 e slide que o slick ainda nao
     posicionou, e promove-lo ali desfaria o deferimento do mobile.

     E a margem e SO vertical (`200px 0px`): no grid do desktop a rolagem e vertical e o
     pre-carregamento e bem-vindo; no carrossel do mobile a vizinhanca e horizontal, e
     expandir nesse eixo promoveria o proximo slide — que e exatamente o que este
     deferimento existe para evitar. */
  var SELECTOR_SLIDE = "img.gd-slide-lazy[data-src]";

  function tiraShimmer() {
    this.classList.remove("gd-slide-shimmer");
  }

  var observerSlide = null;

  function promoveUmSlide(im) {
    if (!im || !im.dataset.src) return;
    if (im.dataset.srcset) {
      im.srcset = im.dataset.srcset;
      im.removeAttribute("data-srcset");
    }
    // o shimmer sai no load, nao aqui: entre escrever o src e a imagem chegar existe
    // justamente a espera que ele cobre. `once` para nao vazar listener nos clones que
    // o slick cria. O handler usa `this` em vez de fechar sobre a variavel do laco:
    // `var` tem escopo de funcao, e o closure apagaria o shimmer sempre da ULTIMA imagem.
    im.addEventListener("load", tiraShimmer, { once: true });
    im.addEventListener("error", tiraShimmer, { once: true });

    im.src = im.dataset.src;
    im.removeAttribute("data-src");
    im.classList.remove("gd-slide-lazy");
    if (observerSlide) observerSlide.unobserve(im);
  }

  function promoveSlides(escopo) {
    var alvo = escopo && escopo.querySelectorAll ? escopo : document;
    var slides = alvo.querySelectorAll(SELECTOR_SLIDE);
    for (var i = 0; i < slides.length; i++) promoveUmSlide(slides[i]);
    return slides.length;
  }

  if ("IntersectionObserver" in window) {
    observerSlide = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var r = entry.boundingClientRect;
          if (entry.isIntersecting && r.width > 0 && r.height > 0) {
            promoveUmSlide(entry.target);
          }
        });
      },
      { rootMargin: "200px 0px" }
    );
  }

  function observaSlides(escopo) {
    if (!observerSlide) return promoveSlides(escopo);
    var alvo = escopo && escopo.querySelectorAll ? escopo : document;
    var slides = alvo.querySelectorAll(SELECTOR_SLIDE);
    for (var i = 0; i < slides.length; i++) observerSlide.observe(slides[i]);
    return slides.length;
  }

  function naGaleria(el) {
    return !!(
      el &&
      el.closest &&
      el.closest(
        ".productView-image, .product-single__media-group, [data-product-single-media-group]"
      )
    );
  }

  ["pointerdown", "touchstart", "keydown"].forEach(function (evt) {
    document.addEventListener(
      evt,
      function (e) {
        if (evt === "keydown" || naGaleria(e.target)) promoveSlides(document);
      },
      { passive: true, capture: true }
    );
  });

  window.gdSlides = { promove: promoveSlides, observa: observaSlides };

  /* ICONES DE HOVER DOS CARDS — ver docs/performance/html-e-main-thread.md

     snippets/product-card-02.liquid emite os .card-icon-hover com data-src. Eles so
     aparecem no :hover do card, entao em aparelho de toque nunca sao vistos e nao ha
     motivo para baixa-los: eram 48 arquivos e 103 KiB competindo por banda antes do LCP
     da home. Aqui a promocao acontece no primeiro pointerover do card (delegado, porque
     pointerenter nao borbulha e os cards sao trocados por AJAX). */
  document.addEventListener(
    "pointerover",
    function (e) {
      var card = e.target.closest && e.target.closest(".product-item");
      if (!card || card.dataset.iconesHover === "true") return;
      card.dataset.iconesHover = "true";
      var icones = card.querySelectorAll("img.card-icon-hover[data-src]");
      for (var i = 0; i < icones.length; i++) {
        icones[i].src = icones[i].dataset.src;
        icones[i].removeAttribute("data-src");
      }
    },
    { passive: true }
  );

  function scanTudo() {
    scan();
    scanImg();
    observaSlides();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scanTudo);
  } else {
    scanTudo();
  }

  // Markup novo entra por caminhos demais pra listar um por um — os slides que o swiper
  // CLONA nas galerias, a .productView do gd-variant-swap.js, o quick view, o editor de
  // tema. Um MutationObserver cobre todos de uma vez, e observe() é idempotente, então
  // re-observar um vídeo já visto não custa nada.
  if ("MutationObserver" in window) {
    var queued = false;

    new MutationObserver(function (mutations) {
      if (queued) return;

      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;

        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;

          if (
            (node.matches &&
              (node.matches(SELECTOR) || node.matches(SELECTOR_IMG))) ||
            (node.querySelector &&
              (node.querySelector(SELECTOR) ||
                node.querySelector(SELECTOR_IMG)))
          ) {
            queued = true;
            setTimeout(function () {
              queued = false;
              scanTudo();
            }, 0);
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
